module.exports = __webpack_public_path__ + "static/media/chasis.a7b007a8.png";